<script>
  import IsSensitive from '$icons/IsSensitiveIcon.svelte';

  export let src;
  export let isSensitive;
</script>

<div class="flex items-center justify-center w-full h-full">
  <div class="relative z-0 w-full">
    <div
      class="object-cover w-full m-auto aspect-square rounded-10 overflow-hidden opacity-60 blur-[15px]"
      style="background-image: url({src[0] || src});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;"
    />
    <div class="absolute inset-0 z-10">
      <div class="w-full h-full m-auto aspect-square rounded-10 bg-color-black-dark opacity-80">
        <div class="flex flex-col items-center justify-center h-full">
          <div class="flex flex-col items-center mt-10">
            <IsSensitive />

            <div class="p-3 text-center">
              <h2 class="mb-2 text-lg text-white">Sensitive Content</h2>
              <p class="text-[#FFFFFF] opacity-50 text-xs">
                This photo contains sensitive content which some people may find offensive or
                disturbing
              </p>
            </div>
          </div>
          <div class="flex flex-col items-end justify-end h-10 mb-10">
            <div class="w-full text-center">
              <hr class="w-[200px] text-[#FFFFFF] opacity-30 mb-2" />
              <button
                class="w-full text-[#FFFFFF] text-sm text-left transition ease-in-out delay-150"
                on:click={() => (isSensitive = false)}
              >
                See Photo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
